import { indexOf, keysIn, valuesIn } from 'lodash';
import { searchTypes } from '../../common/helpers/ui/searchTypes';

export const translateSearchType = (type) => {
  const index = indexOf(valuesIn(searchTypes), type);
  if (index > -1) {
    return keysIn(searchTypes)[index];
  }
  return type;
};
